import React from "react";
import OnboardingLayout from "../../../components/layout/OnboardingLayout";
import SystemBanner from "../../../components/ui/SystemBanner";

const DEFAULT_STEPS = ["Business Details", "Verification", "Done"];

const WHAT_NEXT = [
  "Our team reviews your submitted documents",
  "You'll receive an email once a decision is made",
  "Approved accounts get instant access to BRNX",
];

// Offline KYB — shown when the user's account is PENDING and
// REACT_APP_KYB_ENABLED is false (documents shared offline).
const KYBPending = () => (
  <OnboardingLayout steps={DEFAULT_STEPS} currentStep={1}>
    <div className="bg-cardBg border border-cardBorder rounded-card shadow-card p-8">
      <SystemBanner
        type="warning"
        message="Your account is pending verification. Complete KYB to start using BRNX."
      />

      <div className="text-center py-4">
        {/* Hourglass / clock icon */}
        <div className="w-16 h-16 bg-statusOrangeBg rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-statusOrange"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="text-xl font-bold text-textPrimary mb-2">Verification Under Review</h1>
        <p className="text-sm text-textMuted mb-8">
          We're reviewing your business documents. This usually takes 1–2 business days.
        </p>

        {/* What happens next */}
        <div className="text-left bg-pageBg border border-cardBorder rounded-lg p-4 mb-8">
          <p className="text-sm font-semibold text-textPrimary mb-3">What happens next</p>
          <ul className="space-y-2">
            {WHAT_NEXT.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm text-textMuted">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-textMuted flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <button
          type="button"
          className="btn-outline w-auto px-8 mx-auto"
          onClick={() => window.open("mailto:support@borderless.world", "_blank")}
        >
          Contact Support
        </button>
      </div>
    </div>
  </OnboardingLayout>
);

export default KYBPending;
